import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './i18n';
import { initSentry } from './utils/sentry';
import * as serviceWorkerRegistration from './pwa/serviceWorkerRegistration';

// Architecture Rule 48: initialize Sentry before first React render.
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (process.env.REACT_APP_PWA_ENABLED !== 'false') {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      window.dispatchEvent(new CustomEvent('app:update-available', { detail: registration }));
    },
    onSuccess: () => {
      console.info('Service worker registered for offline support.');
    },
  });
}
